import { configureEcho, echo as resolveEcho } from '@laravel/echo-vue'
import type Echo from 'laravel-echo'
import Pusher, { type AuthorizerCallback } from 'pusher-js/with-encryption/index.js'

function createEcho(): Echo<'reverb'> {
  const { host, port, scheme } = window.reverbConfig
  const forceTLS = scheme === 'https'

  configureEcho<'reverb'>({
    Pusher,
    broadcaster: 'reverb',
    cluster: '',
    forceTLS,
    key: 'app',
    wsHost: host,
    wsPort: port,
    wssPort: port,
    encrypted: forceTLS,
    enabledTransports: ['wss', 'ws'],
    wsPath: '',
    authorizer: (channel) => ({
      authorize: async (socketId, callback: AuthorizerCallback) => {
        try {
          const { data } = await api.post(
            'broadcasting/auth',
            {
              socket_id: socketId,
              channel_name: channel.name,
            },
            { key: channel.name },
          )

          // Make sure that broadcast->toOthers works.
          window.api.headers['X-Socket-ID'] = socketId

          callback(null, data)
        } catch (error) {
          callback(error as Error, null)
        }
      },
    }),
  })

  const echo = resolveEcho<'reverb'>()

  // Handle reconnections — socket ID can change on reconnect.
  echo.connector.pusher.connection.bind('state_change', ({ current }: { current: string }) => {
    if (current === 'connected') {
      window.api.headers['X-Socket-ID'] = echo.socketId()
    }
  })

  return echo
}

export { createEcho }
